import { StackableFusuma } from '~/components/modal/StackableFusuma'
import { useReserveOverlay } from '~/navigation'
import { CouponDetailContainer } from './CouponDetailContainer'
import type { CouponDetailListProps } from './CouponDetailList'

export function CouponFusuma({
  title = 'クーポン詳細',
  detailDirection = 'vertical',
}: { title?: string } & Pick<CouponDetailListProps, 'detailDirection'>) {
  const [context, willBeUnmounted] = useReserveOverlay('COUPON')
  if (context === undefined) {
    return null
  }
  const { restaurantId } = context
  return (
    <StackableFusuma title={title} willBeUnmounted={willBeUnmounted} layout="full">
      <CouponDetailContainer restaurantId={restaurantId} detailDirection={detailDirection} />
    </StackableFusuma>
  )
}
